module.exports = __webpack_public_path__ + "static/media/Pic-0043.168d5c62.jpg";